import actionTypes from '../constants/action-types';

const paymentMethodsState = {
  paymentMethods: null,
  showPaymentMethodModal: false,
  paymentMethodTypes: null,
  showAddPaymentMethodModal: false,
  selectedPaymentMethodType: null,
  selectedPaymentMethod: null,
  showPaymentMethodDetailsModal: false,
};

export const paymentMethodsReducer = (state = paymentMethodsState, payload) => {
  switch (payload.type) {
    case actionTypes.HANDLE_SUCCESS_GET_PAYMENT_METHODS:
      return { ...state, paymentMethods: payload.data };
    case actionTypes.TOGGLE_PAYMENT_METHOD_MODAL:
      return { ...state, showPaymentMethodModal: payload.data };
    case actionTypes.HANDLE_SUCCESS_GET_PAYMENT_METHOD_TYPES:
      return { ...state, paymentMethodTypes: payload.data };
    case actionTypes.TOGGLE_ADD_PAYMENT_METHOD_MODAL:
      return { ...state, showAddPaymentMethodModal: payload.data };
    case actionTypes.HANDLE_SELECTED_PAYMENT_METHOD_TYPE:
      return { ...state, selectedPaymentMethodType: payload.data };
    case actionTypes.TOGGLE_PAYMENT_METHOD_DETAILS_MODAL:
      return { ...state, showPaymentMethodDetailsModal: payload.data.show, selectedPaymentMethod: payload.data.paymentMethod };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/reducers/payment-methods-reducer.js